export const SET_USER_DISTRIBUTIONS_ONLY = 'SET_USER_DISTRIBUTIONS_ONLY';

export const setUserDistributionsOnly = userDistributionsOnly => ({
  type: SET_USER_DISTRIBUTIONS_ONLY,
  payload: userDistributionsOnly,
});
